
import capitalize from 'lodash/capitalize';

import * as Yup from 'yup';

import REGEXP from './regexp';

class BaseValidator {
  constructor(params) {
    const { label = 'Field', required = true, messages = {} } = params || {};
    this.label = label;
    this.required = required;
    this.messages = {
      ...this.defaultMessages,
      ...messages,
    };
  }

  get defaultMessages() {
    return {
      required: 'Field is required',
    };
  }

  get schema() {
    throw new Error('Not Implemented Error.');
  }
}

class RegexValidator extends BaseValidator {
  get regex() {
    throw new Error('Not Implemented Error.');
  }

  get defaultMessages() {
    return {
      invalid: 'Field is invalid',
      required: 'Field is required',
    };
  }

  get schema() {
    const baseSchema = Yup.string().matches(this.regex, this.messages.invalid);
    return this.required
      ? baseSchema.required(this.messages.required)
      : Yup.lazy((value) => (value === '' ? Yup.string() : baseSchema));
  }
}

class EmailValidator extends RegexValidator {
  get regex() {
    return REGEXP.email;
  }

  get defaultMessages() {
    return {
      invalid: 'Email is invalid',
      required: 'Field is required',
    };
  }
}

class PasswordValidator extends BaseValidator {
  constructor(props = {}) {
    const { min = 8, ...restProps } = props || {};
    super(restProps);
    this.min = min;
  }

  get defaultMessages() {
    return {
      min: `${capitalize(this.label)} should have minumum 8 symbols`,
      required: `${capitalize(this.label)} is required`,
    };
  }

  get schema() {
    return this.required
      ? Yup.string().required(this.messages.required).min(this.min, this.messages.min)
      : Yup.string().min(this.min, this.messages.min);
  }
}

const REGISTRY = {
  email: EmailValidator,
  password: PasswordValidator,
};

function createValidator(key, params) {
  if (key in REGISTRY) {
    const Base = REGISTRY[key];
    return new Base(params).schema;
  }
  throw new Error(`Validator with key=${key} does not exists.`);
}


function createSchema(obj) {
  const schema = Object.entries(obj).reduce((fields, [key, value]) => {
    const isSchema = Boolean(Yup.isSchema(value));
    return { ...fields, [key]: isSchema ? value : createValidator(value.type, value) };
  }, {});
  return Yup.object(schema);
}


export { createSchema, createValidator, Yup };
